<template>
  <div class="header">
    <div class="container-fluid">
      <div class="card" style="margin-top: 50px">
        <Header />
        <div class="card-body">
          <div class="row mb-4 align-items-center">
            <div class="col-sm-2 d-flex align-items-center">
              <label class="fw-semibold">IDP Period</label>
            </div>
            <div class="col-sm-10 d-flex align-items-center">
              <v-select
                :options="idpPeriodOptions"
                v-model="filters.idp_period_id"
                :reduce="option => option.value"
                label="text"
                class="w-50"
                placeholder="-- Select a period --"
              />
            </div>
          </div>
          <Summary :isLoadingSummary="isLoadingSummary" :summaryData="summaryIdpLearning" />

          <div class="row align-items-center justify-content-between mb-4">
            <div class="col-md-2">
              <h4 class="mb-0 font-weight-bold">Course List</h4>
            </div>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center gap-2">
                <div>
                  <b-form-input class="w-full" v-model="filters.search" placeholder="Type Here..." @keyup.enter="onSearch" />
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-outline-danger position-relative"
                    @click="showFilterModal"
                    style="height: 27.88px"
                  >
                    <span class="fe fe-sliders"></span> Filter
                    <span
                      v-if="activeFiltersCount > 0"
                      class="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
                      style="font-size: 0.65rem; padding: 0.2rem 0.4rem"
                    >
                      {{ activeFiltersCount }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="activeFiltersCount > 0" class="mb-3">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <small class="text-muted">Active Filters:</small>

              <span v-if="filters.training_scope" class="badge bg-light text-dark border">
                Training Scope: {{ filters.training_scope }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_scope')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.training_category" class="badge bg-light text-dark border">
                Training Category: {{ filters.training_category === 'mandatory' ? 'Mandatory' : 'Development' }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_category')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.platform" class="badge bg-light text-dark border">
                Platform: {{ filters.platform }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('platform')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.training_method_id" class="badge bg-light text-dark border">
                Training Method ID: {{ filters.training_method_id }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_method_id')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.training_type" class="badge bg-light text-dark border">
                Training Type: {{ filters.training_type }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_type')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.competency_id" class="badge bg-light text-dark border">
                Competency: {{ filters.competency_id }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('competency_id')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-2" @click="resetFilters">Clear All</button>
            </div>
          </div>

          <CardGrid
            :isLoading="isLoading"
            :items="idpLearnings.data"
            :page="idpLearnings.page"
            :page-size="idpLearnings.limit"
            :total-items="idpLearnings.totalItems"
            :total-pages="idpLearnings.totalPages"
            @page-change="onPageChange"
            @open-modal="openDetailModal"
          />

          <StructuredLearningModal
            :modal-id="'structured-learning-modal'"
            :data="modalData"
            :is-loading="isModalLoading"
            @submit-enrollment="submitUnEnrollment"
            @close="showModal = false"
          />

          <modal-filter
            v-model="filters"
            @apply-filters="applyFilters"
            @reset-filters="resetFilters"
            :training-type-options="trainingTypes"
            :competency-options="competencies"
            :training-method-options="trainingMethods"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logic from "./main.logic";
import Header from "./components/header.vue";
import Summary from "./components/summary.vue";
import CardGrid from "./components/card-grid.vue";
import StructuredLearningModal from "./modal/structured-learning-modal.vue";
import ModalFilter from "./modal/filter-modal.vue";

export default {
  name: "IDPEnrollmentPage",
  components: {
    Header,
    CardGrid,
    Summary,
    StructuredLearningModal,
    ModalFilter,
  },
  mixins: [logic],
};
</script>
